export default __webpack_public_path__ + "static/media/vbAd.dfee6f593c8ae10418389e2c19f3369e.webp";